/**
 * Given tags in a form of a string or an array of strings, normalizes them to
 * an array of strings.
 */
export const normalizeTags = (tags?: string | string[]) => {
  if (Array.isArray(tags)) {
    if (tags.length === 0) {
      return undefined
    }

    return tags
  }

  if (typeof tags !== 'string') {
    return undefined
  }

  return tags.split(',')
}
